import {
    useEffect,
    useState,
} from 'react';

import Select from 'react-select';


import {
    EditorContent,
    useEditor,
} from '@tiptap/react';


import StarterKit from '@tiptap/starter-kit';

import api from '../../../api/api';

import {
    IMAGE_URL,
} from '../../../path';

type Props = {
    recipe?: any;
    recipes: any[];
    onClose: () => void;
    isFanRecipe: boolean;
    onSave: (
        data: any
    ) => void;
};

export default function RecipeModal({

                                        recipe,
                                        recipes,
                                        isFanRecipe,
                                        onClose,
                                        onSave,

                                    }: Props)
{
    const [name, setName] =
        useState(
            recipe?.name || ''
        );

    const [featured, setFeatured] =
        useState(
            recipe?.featured ?? false
        );

    const [isActive, setIsActive] =
        useState(
            recipe?.is_active ?? true
        );

    const [
        preparationTime,
        setPreparationTime
    ] = useState(
        recipe?.preparation_time || ''
    );

    const [
        cookingTime,
        setCookingTime
    ] = useState(
        recipe?.cooking_time || ''
    );

    const [
        servings,
        setServings
    ] = useState(
        recipe?.servings || ''
    );

    const [description, setDescription] = useState(recipe?.description || '');

    const [headerImage, setHeaderImage] =
        useState<File | null>(
            null
        );

    const [
        featuredImage,
        setFeaturedImage
    ] = useState<File | null>(
        null
    );


    const [
        headerPreview,
        setHeaderPreview
    ] = useState(
        recipe?.header_image || ''
    );

    // const [
    //     galleryImages,
    //     setGalleryImages
    // ] = useState<File[]>([]);



    const [
        coverImage,
        setCoverImage
    ] = useState<File | null>(null);

    const [
        coverPreview,
        setCoverPreview
    ] = useState(
        recipe?.cover_image || ''
    );

    const [
        featuredPreview,
        setFeaturedPreview
    ] = useState(
        recipe?.featured_image || ''
    );

    const [options, setOptions] =
        useState<any>({
            products: [],

            cuisines: [],

            difficulties: [],

            occasions: [],

            proteins: [],

            times: [],

            dietaryPreferences: [],

            cookingMethods: [],

        });

    const [
        selectedCuisines,
        setSelectedCuisines
    ] = useState<any[]>([]);

    const [
        selectedDifficulties,
        setSelectedDifficulties
    ] = useState<any[]>([]);

    const [
        selectedOccasions,
        setSelectedOccasions
    ] = useState<any[]>([]);

    const [
        selectedProteins,
        setSelectedProteins
    ] = useState<any[]>([]);

    const [
        selectedTimes,
        setSelectedTimes
    ] = useState<any[]>([]);

    const [
        selectedDietaryPreferences,
        setSelectedDietaryPreferences
    ] = useState<any[]>([]);

    const [
        selectedCookingMethods,
        setSelectedCookingMethods
    ] = useState<any[]>([]);

    const [
        selectedProduct,
        setSelectedProduct
    ] = useState<any>(
        null
    );

    const featuredCount =
        recipes.filter(
            (
                item
            ) =>
                item.featured
        ).length;

    const ingredientsEditor =
        useEditor({

            extensions: [
                StarterKit,
            ],

            content:
                recipe?.ingredients || '',

        });

    const methodEditor =
        useEditor({

            extensions: [
                StarterKit,
            ],

            content:
                recipe?.method || '',

        });

    useEffect(() => {

        loadOptions();

    }, []);

    const handleCoverImageUpload = async (
        file: File
    ) => {

        if (!recipe) {
            return;
        }

        try {

            const formData =
                new FormData();

            formData.append(
                'image',
                file
            );

            await api.post(

                `/recipes/${recipe.id}/cover-image`,

                formData,

                {
                    headers: {
                        'Content-Type':
                            'multipart/form-data',
                    },
                }

            );

            setCoverImage(file);

            setCoverPreview(
                URL.createObjectURL(file)
            );

        } catch (error) {

            console.error(error);

            alert(
                'Failed to upload cover image.'
            );

        }
    };

    const loadOptions = async () => {

        try {

            const response =
                await api.get(
                    '/recipe-options'
                );

            setOptions(
                response.data
            );

        } catch (
            error
            ) {

            console.error(
                error
            );

        }
    };

    useEffect(() => {

        if (
            !recipe ||
            !options.cuisines.length
        ) {
            return;
        }

        setSelectedCuisines(

            recipe.cuisines?.map(
                (item: any) => ({

                    value:
                    item.id,

                    label:
                    item.name,

                })
            ) || []

        );

        setSelectedProduct(

            recipe?.product
                ? {

                    value:
                    recipe.product.id,

                    label:
                        `${recipe.product.name}: ${recipe.product.flavour}`,

                }
                : null

        );

        setSelectedDifficulties(

            recipe.difficulties?.map(
                (item: any) => ({

                    value:
                    item.id,

                    label:
                    item.name,

                })
            ) || []

        );

        setSelectedOccasions(

            recipe.occasions?.map(
                (item: any) => ({

                    value:
                    item.id,

                    label:
                    item.name,

                })
            ) || []

        );

        setSelectedProteins(

            recipe.proteins?.map(
                (item: any) => ({

                    value:
                    item.id,

                    label:
                    item.name,

                })
            ) || []

        );

        setSelectedTimes(

            recipe.times?.map(
                (item: any) => ({

                    value:
                    item.id,

                    label:
                    item.name,

                })
            ) || []

        );

        setSelectedDietaryPreferences(

            recipe.dietary_preferences?.map(
                (item: any) => ({

                    value:
                    item.id,

                    label:
                    item.name,

                })
            ) || []

        );

        setSelectedCookingMethods(

            recipe.cooking_methods?.map(
                (item: any) => ({

                    value:
                    item.id,

                    label:
                    item.name,

                })
            ) || []

        );

    }, [
        recipe,
        options,
    ]);



    const getImageUrl = (
        path?: string
    ) => {

        if (!path) {
            return '';
        }

        if (
            path.startsWith(
                'http'
            ) ||
            path.startsWith(
                'blob:'
            )
        ) {

            return path;
        }

        return `${IMAGE_URL}${path}`;
    };

    const toOptions = (
        items: any[] = []
    ) => {

        return items.map(
            (
                item
            ) => ({

                value:
                item.id,

                label:
                item.name,

            })
        );

    };

    const cuisineOptions =
        toOptions(
            options.cuisines
        );

    const difficultyOptions =
        toOptions(
            options.difficulties
        );

    const occasionOptions =
        toOptions(
            options.occasions
        );

    const proteinOptions =
        toOptions(
            options.proteins
        );

    const timeOptions =
        toOptions(
            options.times
        );

    const dietaryPreferenceOptions =
        toOptions(
            options.dietaryPreferences
        );

    const cookingMethodOptions =
        toOptions(
            options.cookingMethods
        );

    const productOptions =
        options.products.map(
            (item: any) => ({

                value:
                item.id,

                label:
                    `${item.name}: ${item.flavour}`,

            })
        );

    const handleHeaderImageUpload = async (
        file: File
    ) => {

        if (
            !recipe
        ) {
            return;
        }

        try {

            const formData =
                new FormData();

            formData.append(
                'image',
                file,
            );

            await api.post(

                `/recipes/${recipe.id}/header-image`,

                formData,

                {
                    headers: {
                        'Content-Type':
                            'multipart/form-data',
                    },
                }

            );

            setHeaderImage(
                file
            );

            setHeaderPreview(
                URL.createObjectURL(
                    file
                )
            );

        } catch (
            error
            ) {

            console.error(
                error
            );

            alert(
                'Failed to upload preview image.'
            );

        }
    };

    const handleFeaturedImageUpload = async (
        file: File
    ) => {

        if (
            !recipe
        ) {
            return;
        }

        try {

            const formData =
                new FormData();

            formData.append(
                'image',
                file
            );

            await api.post(

                `/recipes/${recipe.id}/featured-image`,

                formData,

                {
                    headers: {
                        'Content-Type':
                            'multipart/form-data',
                    },
                }

            );

            setFeaturedImage(
                file
            );

            setFeaturedPreview(
                URL.createObjectURL(
                    file
                )
            );

        } catch (
            error
            ) {

            console.error(
                error
            );

            alert(
                'Failed to upload featured image.'
            );

        }
    };

    const handleSubmit = (
        e: React.FormEvent
    ) => {

        e.preventDefault();

        if (
            featured &&
            !recipe &&
            featuredCount >= 2
        ) {

            alert(
                'A maximum of 2 featured recipes is allowed.'
            );

            return;
        }

        const formData =
            new FormData();

        formData.append(
            'name',
            name
        );
        formData.append(
            'description',
            description
        );

        formData.append(
            'featured',
            featured ? '1' : '0'
        );

        formData.append(
            'fan',
            isFanRecipe ? '1' : '0'
        );

        formData.append(
            'is_active',
            isActive ? '1' : '0'
        );

        formData.append('preparation_time', preparationTime);
        formData.append('cooking_time', cookingTime);
        formData.append('servings', servings);

        formData.append(
            'ingredients',
            ingredientsEditor?.getHTML() || ''
        );

        formData.append(
            'method',
            methodEditor?.getHTML() || ''
        );

        formData.append(
            'product_id',
            selectedProduct?.value || ''
        );

        selectedCuisines.forEach(
            item => {

                formData.append(
                    'cuisines[]',
                    item.value
                );

            }
        );

        selectedDifficulties.forEach(
            item => {

                formData.append(
                    'difficulties[]',
                    item.value
                );

            }
        );

        selectedOccasions.forEach(
            item => {

                formData.append(
                    'occasions[]',
                    item.value
                );

            }
        );

        selectedProteins.forEach(
            item => {

                formData.append(
                    'proteins[]',
                    item.value
                );

            }
        );

        selectedTimes.forEach(
            item => {

                formData.append(
                    'times[]',
                    item.value
                );

            }
        );

        selectedDietaryPreferences.forEach(
            item => {

                formData.append(
                    'dietary_preferences[]',
                    item.value
                );

            }
        );

        selectedCookingMethods.forEach(
            item => {

                formData.append(
                    'cooking_methods[]',
                    item.value
                );

            }
        );

        if (
            headerImage
        ) {

            formData.append(
                'header_image',
                headerImage
            );
        }

        if (
            featuredImage
        ) {

            formData.append(
                'featured_image',
                featuredImage
            );
        }

        if (
            coverImage
        ) {

            formData.append(
                'cover_image',
                coverImage
            );

        }


        onSave(
            formData
        );

    };

    return (

        <div
            className="modal-overlay"
            onClick={onClose}
        >

            <div
                className="modal-box"
                onClick={(e) => e.stopPropagation()}
            >

                <h2>

                    {recipe
                        ? 'Edit Recipe'
                        : 'Add Recipe'}

                </h2>

                <form
                    className="modal-form"
                    onSubmit={
                        handleSubmit
                    }
                >

                    <label>
                        Name
                    </label>

                    <input
                        type="text"
                        value={name}
                        onChange={(e) =>
                            setName(
                                e.target.value
                            )
                        }
                        required
                    />

                    <label>
                        Description
                    </label>

                    <textarea
                        value={description}
                        onChange={(e) =>
                            setDescription(
                                e.target.value
                            )
                        }
                        required
                        rows={10}
                    />

                    <label>
                        Product
                    </label>

                    <Select
                        options={
                        productOptions
                    }
                        value={
                        selectedProduct
                    }
                        onChange={(value) => {



                        setSelectedProduct(
                        value
                        );

                    }}
                        isClearable
                        />

                    <label>
                        Preparation Time
                    </label>

                    <input
                        type="text"
                        value={preparationTime}
                        onChange={(e) =>
                            setPreparationTime(e.target.value)
                        }
                    />

                    <label>
                        Cooking Time
                    </label>

                    <input
                        type="text"
                        value={cookingTime}
                        onChange={(e) =>
                            setCookingTime(e.target.value)
                        }
                    />

                    <label>
                        Servings
                    </label>

                    <input
                        type="text"
                        value={servings}
                        onChange={(e) =>
                            setServings(e.target.value)
                        }
                    />

                    {recipe && (

                        <>
                            <label>
                                Preview Image
                            </label>

                            {headerPreview && (

                                <img
                                    src={
                                        getImageUrl(
                                            headerPreview
                                        )
                                    }
                                    alt=""
                                    className="image-preview"
                                />

                            )}

                            <p className="field-hint">
                                Maximum file size: 2MB
                            </p>

                            <input
                                type="file"
                                accept="image/*"
                                onChange={(e) => {

                                    const file =
                                        e.target.files?.[0];

                                    if (
                                        !file
                                    ) {
                                        return;
                                    }

                                    if (
                                        file.size >
                                        2 * 1024 * 1024
                                    ) {

                                        alert(
                                            'Image must be 2MB or smaller.'
                                        );

                                        return;
                                    }

                                    handleHeaderImageUpload(
                                        file
                                    );

                                }}
                            />
                            <label>
                                Cover Image
                            </label>

                            {coverPreview && (

                                <img
                                    src={getImageUrl(coverPreview)}
                                    alt=""
                                    className="image-preview"
                                />

                            )}

                            <p className="field-hint">
                                Maximum file size: 2MB
                            </p>

                            <input
                                type="file"
                                accept="image/*"
                                onChange={(e) => {

                                    const file =
                                        e.target.files?.[0];

                                    if (!file) {
                                        return;
                                    }

                                    if (
                                        file.size >
                                        2 * 1024 * 1024
                                    ) {

                                        alert(
                                            'Image must be 2MB or smaller.'
                                        );

                                        return;
                                    }

                                    handleCoverImageUpload(file);

                                }}
                            />

                            <label>
                                Featured Image
                            </label>

                            {featuredPreview && (

                                <img
                                    src={
                                        getImageUrl(
                                            featuredPreview
                                        )
                                    }
                                    alt=""
                                    className="image-preview"
                                />

                            )}

                            <p className="field-hint">
                                Maximum file size: 2MB
                            </p>

                            <input
                                type="file"
                                accept="image/*"
                                onChange={(e) => {

                                    const file =
                                        e.target.files?.[0];

                                    if (
                                        !file
                                    ) {
                                        return;
                                    }

                                    if (
                                        file.size >
                                        2 * 1024 * 1024
                                    ) {

                                        alert(
                                            'Image must be 2MB or smaller.'
                                        );

                                        return;
                                    }

                                    handleFeaturedImageUpload(
                                        file
                                    );

                                }}
                            />

                        </>

                    )}

                    {!recipe && (

                        <>

                            <label>
                                Preview Image
                            </label>

                            <input
                                type="file"
                                accept="image/*"
                                onChange={(e) => {

                                    const file =
                                        e.target.files?.[0];

                                    if (!file) {
                                        return;
                                    }

                                    setHeaderImage(
                                        file
                                    );

                                    setHeaderPreview(
                                        URL.createObjectURL(
                                            file
                                        )
                                    );

                                }}
                            />

                            <label>
                                Featured Image
                            </label>

                            <input
                                type="file"
                                accept="image/*"
                                onChange={(e) => {

                                    const file =
                                        e.target.files?.[0];

                                    if (!file) {
                                        return;
                                    }

                                    setFeaturedImage(
                                        file
                                    );

                                    setFeaturedPreview(
                                        URL.createObjectURL(
                                            file
                                        )
                                    );

                                }}
                            />


                            <label>
                                Cover Image
                            </label>

                            <input
                                type="file"
                                accept="image/*"
                                onChange={(e) => {

                                    const file =
                                        e.target.files?.[0];

                                    if (!file) {
                                        return;
                                    }

                                    setCoverImage(file);

                                    setCoverPreview(
                                        URL.createObjectURL(file)
                                    );

                                }}
                            />

                            {coverPreview && (

                                <img
                                    src={getImageUrl(coverPreview)}
                                    alt=""
                                    className="image-preview"
                                />

                            )}

                        </>

                    )}

                    <label>
                        Featured
                    </label>

                    <select
                        value={
                            featured
                                ? '1'
                                : '0'
                        }
                        onChange={(e) =>
                            setFeatured(
                                e.target.value ===
                                '1'
                            )
                        }
                    >

                        <option value="1">
                            Yes
                        </option>

                        <option value="0">
                            No
                        </option>

                    </select>

                    <label>
                        Active
                    </label>

                    <select
                        value={
                            isActive
                                ? '1'
                                : '0'
                        }
                        onChange={(e) =>
                            setIsActive(
                                e.target.value ===
                                '1'
                            )
                        }
                    >

                        <option value="1">
                            Yes
                        </option>

                        <option value="0">
                            No
                        </option>

                    </select>

                    <label>
                        Cuisines
                    </label>

                    <Select
                        isMulti
                        options={
                            cuisineOptions
                        }
                        value={
                            selectedCuisines
                        }
                        onChange={(value: any) =>
                            setSelectedCuisines(
                                value as any[]
                            )
                        }
                    />

                    <label>
                        Difficulties
                    </label>

                    <Select
                        isMulti
                        options={
                            difficultyOptions
                        }
                        value={
                            selectedDifficulties
                        }
                        onChange={(value: any) =>
                            setSelectedDifficulties(
                                value as any[]
                            )
                        }
                    />

                    <label>
                        Occasions
                    </label>

                    <Select
                        isMulti
                        options={
                            occasionOptions
                        }
                        value={
                            selectedOccasions
                        }
                        onChange={(value: any) =>
                            setSelectedOccasions(
                                value as any[]
                            )
                        }
                    />

                    <label>
                        Proteins
                    </label>

                    <Select
                        isMulti
                        options={
                            proteinOptions
                        }
                        value={
                            selectedProteins
                        }
                        onChange={(value: any) =>
                            setSelectedProteins(
                                value as any[]
                            )
                        }
                    />

                    <label>
                        Times
                    </label>

                    <Select
                        isMulti
                        options={
                            timeOptions
                        }
                        value={
                            selectedTimes
                        }
                        onChange={(value: any) =>
                            setSelectedTimes(
                                value as any[]
                            )
                        }
                    />

                    <label>
                        Dietary Preferences
                    </label>

                    <Select
                        isMulti
                        options={
                            dietaryPreferenceOptions
                        }
                        value={
                            selectedDietaryPreferences
                        }
                        onChange={(value: any) =>
                            setSelectedDietaryPreferences(
                                value as any[]
                            )
                        }
                    />

                    <label>
                        Cooking Methods
                    </label>

                    <Select
                        isMulti
                        options={
                            cookingMethodOptions
                        }
                        value={
                            selectedCookingMethods
                        }
                        onChange={(value: any) =>
                            setSelectedCookingMethods(
                                value as any[]
                            )
                        }
                    />

                    <label>
                        Ingredients
                    </label>

                    <div className="tiptap-editor">
                        <div className="editor-toolbar">
                            <button
                                type="button"
                                onClick={() => ingredientsEditor?.chain().focus().toggleBulletList().run()}
                            >
                                • List
                            </button>

                            <button
                                type="button"
                                onClick={() => ingredientsEditor?.chain().focus().toggleOrderedList().run()}
                            >
                                1. List
                            </button>
                        </div>

                        <EditorContent
                            editor={
                                ingredientsEditor
                            }
                        />

                    </div>

                    <label>
                        Method
                    </label>

                    <div className="tiptap-editor">
                        <div className="editor-toolbar">
                            <button
                                type="button"
                                onClick={() => methodEditor?.chain().focus().toggleBulletList().run()}
                            >
                                • List
                            </button>

                            <button
                                type="button"
                                onClick={() => methodEditor?.chain().focus().toggleOrderedList().run()}
                            >
                                1. List
                            </button>
                        </div>

                        <EditorContent
                            editor={
                                methodEditor
                            }
                        />

                    </div>

                    <div className="modal-actions">

                        <div className="left-actions">

                            <button
                                type="button"
                                className="cancel-btn"
                                onClick={
                                    onClose
                                }
                            >
                                Cancel
                            </button>

                        </div>

                        <div className="right-actions">

                            <button
                                type="submit"
                                className="action-btn"
                            >
                                Save
                            </button>

                        </div>

                    </div>

                </form>

            </div>

        </div>

    );
}
